<template>
  <ul style="column-gap: 10px" class="d-flex">
    <li v-for="(button, idx) in buttons" :key="idx">
      <base-rounded-button v-if="!button.menu" v-bind="button" @click="onButtonClickHandler(button.name)" />
      <menu-items
        v-else
        :items="button.menu"
        :disabled="activeControl === button.name"
        @measurementLength="onMenuItemClickHandler(button.name, $event)"
        @measurementArea="onMenuItemClickHandler(button.name, $event)"
      >
        <template #activator="{ on }">
          <div v-on="on">
            <base-rounded-button v-bind="button" @click="onButtonClickHandler(button.name)" />
          </div>
        </template>
      </menu-items>
    </li>
  </ul>
</template>

<script>
import { sync } from 'vuex-pathify';

import map from '@/mixins/map/map';

import MenuItems from '@/components/shared/MenuItems';
import BaseRoundedButton from '@/components/shared/buttons/BaseRoundedButton';

export default {
  name: 'ControlButtons',
  components: { MenuItems, BaseRoundedButton },
  mixins: [map],
  computed: {
    activeControl: sync('map/activeControl'),
    isMeasurementActive() {
      return this.activeControl === 'measurements';
    },
    buttons() {
      return [
        {
          name: 'zoomIn',
          icon: 'mdi-plus',
          tooltip: 'tooltips.zoomIn',
        },
        {
          name: 'zoomOut',
          icon: 'mdi-minus',
          tooltip: 'tooltips.zoomOut',
        },
        {
          name: 'measurements',
          color: this.isMeasurementActive ? '#fff' : 'secondary',
          icon: this.isMeasurementActive ? 'mdi-cancel' : 'mdi-ruler',
          iconColor: this.isMeasurementActive ? 'secondary' : '#fff',
          tooltip: this.isMeasurementActive ? 'tooltips.turnOffMeasurement' : 'tooltips.measurements',
          isActive: this.isMeasurementActive,
          menu: [
            {
              name: 'measurementLength',
              text: 'menu.measurementLength',
            },
            {
              name: 'measurementArea',
              text: 'menu.measurementArea',
            },
          ],
        },
        {
          name: 'resetView',
          icon: 'mdi-replay',
          tooltip: 'tooltips.resetView',
        },
      ];
    },
  },
  methods: {
    onButtonClickHandler(name) {
      if (this.isMeasurementActive && name === 'measurements') {
        this.activeControl = '';
      } else {
        this.$emit(name);
      }
    },
    onMenuItemClickHandler(name, item) {
      this.activeControl = name;
      this.$emit(item);
    },
  },
};
</script>
